export const ACCESS_TOKEN = 'wz_mp_token';



// WEBPACK FOOTER //
// ./src/utils/constants.ts